
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","width":"31","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"fill":"#353A48","width":"30.8","height":"22","rx":"3.316"}}),_c('path',{attrs:{"d":"M19.453 5.037c3.312 0 5.998 2.72 5.998 6.075s-2.686 6.074-5.998 6.074a5.93 5.93 0 01-3.891-1.451 5.928 5.928 0 01-3.89 1.451c-3.313 0-5.998-2.72-5.998-6.074 0-3.355 2.685-6.075 5.998-6.075a5.93 5.93 0 013.891 1.452 5.922 5.922 0 013.89-1.452z","fill":"#FF5E00"}}),_c('path',{attrs:{"d":"M11.672 5.037a5.93 5.93 0 013.891 1.452 6.088 6.088 0 00-2.108 4.623 6.09 6.09 0 002.107 4.623 5.928 5.928 0 01-3.89 1.451c-3.313 0-5.998-2.72-5.998-6.074 0-3.355 2.685-6.075 5.998-6.075z","fill":"#ED0006"}}),_c('path',{attrs:{"d":"M19.453 5.037c3.312 0 5.998 2.72 5.998 6.075s-2.686 6.074-5.998 6.074a5.93 5.93 0 01-3.892-1.451 6.09 6.09 0 002.108-4.623 6.093 6.093 0 00-2.106-4.623 5.924 5.924 0 013.89-1.452z","fill":"#F9A000"}})])])
          )
        }
      }
    